import * as React from 'react';
import {
  makeStyles,
  tokens,
  Title3,
  Body1,
  Caption1,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  left: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colorNeutralBackground3,
    padding: tokens.spacingHorizontalXXXL,
    '@media (max-width: 768px)': {
      flex: 'none',
      width: '100%',
      padding: tokens.spacingHorizontalXL,
    },
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px',
  },
  right: {
    flex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colorBrandBackground,
    padding: tokens.spacingHorizontalXXXL,
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  welcomeContent: {
    maxWidth: '650px',
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    alignItems: 'center',
  },
  welcomeTitle: {
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: tokens.fontSizeHero1000,
    fontWeight: tokens.fontWeightBold,
    lineHeight: tokens.lineHeightHero1000,
    margin: 0,
  },
  welcomeSubtitle: {
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    opacity: 0.95,
    lineHeight: tokens.lineHeightBase500,
    margin: 0,
  },
  welcomeBody: {
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: tokens.fontSizeBase500,
    lineHeight: tokens.lineHeightBase500,
    opacity: 0.9,
  },
  welcomeFooter: {
    color: tokens.colorNeutralForegroundOnBrand,
    opacity: 0.7,
    fontSize: tokens.fontSizeBase200,
    marginTop: tokens.spacingVerticalXL,
  },
});

interface LoginLayoutProps {
  children: React.ReactNode;
}

const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <div className={styles.formContainer}>
          {children}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.welcomeContent}>
          <Title3 className={styles.welcomeTitle}>Maximize o potencial do seu ERP - Implantei ERP</Title3>          
          <Body1 className={styles.welcomeBody}>
            Ajudamos empresas a tirarem o melhor proveito dos seus ERPs através de implantações estratégicas e acompanhamentos baseados no uso real dos sistemas. Geramos insights valiosos e planos de fast-track para colocar sua empresa nos trilhos e acelerar resultados.
          </Body1>
          <Caption1 className={styles.welcomeFooter}>© 2025 Implantei</Caption1>
        </div>
      </div>
    </div>
  );
};

export default LoginLayout;